<template>
    <CCard>    
        <CCardBody>  
            <CCol sm="12" lg="12" style="padding-left: 0px; padding-right: 0px;">  
                <div class="content-wrapper">
                    <div id="app">                      
                        <ejs-tooltip ref="tooltip" target=".e-rowcell" >
                            <ejs-grid ref='refdata' :dataSource='datas' height='60vh' :allowExcelExport='true' :allowPaging='true' :allowSorting='true' :allowFiltering='true' :allowReordering='true'
                                :toolbar='toolbar' :pageSettings='pageSettings' :filterSettings='filterSettings' :selectionSettings='selectionSettings' :toolbarClick="toolbarClick"
                                :editSettings='editSettings' :recordDoubleClick="recordDoubleClick" :beforeRender="beforeRender" :rowSelected='rowSelected' 
                                :queryCellInfo='onQueryCellInfo' :rowDataBound="onRowDataBound">
                                <e-columns>       
                                  <e-column field='bill_id' headerText='出貨單號' aria-required="true" :isPrimaryKey='true' width='180'></e-column>
                                  <e-column field='bill_date' format="yyyy-MM-dd" type="date" headerText='出貨日期' width='130'></e-column>    
                                  <e-column field='check_date' format="yyyy-MM-dd" type="date" headerText='營運覆核日期' width='150'></e-column>                
                                  <e-column field='check_id' headerText='營運覆核人員' width='150'></e-column>          
                                  <e-column field='bill_status' headerText='標籤狀態' width='150'></e-column>       
                                  <e-column field='bus_person_id' headerText='業務員編號' width='150'></e-column>   
                                  <e-column field='bus_person_name' headerText='業務員姓名' width='150'></e-column>   
                                  <e-column field='enterprise_id' headerText='企業編號' width='130'></e-column>  
                                  <e-column field='enterprise_name' headerText='企業名稱' width='230'></e-column> 
                                  <e-column field='warehouse_id' headerText='倉庫編號' width='130'></e-column>  
                                  <e-column field='source_bill_id' headerText='來源單號' width='180'></e-column>  
                                  <e-column field='contact' headerText='連絡人員' width='150'></e-column>  
                                  <e-column field='contact_phone' headerText='聯絡電話' width='150'></e-column>  
                                  <e-column field='fax' headerText='傳真號碼' width='150'></e-column>                                  
                                  <e-column field='deliver_country' headerText='送貨地址國別' width='150'></e-column>
                                  <e-column field='deliver_address' headerText='送貨地址' width='230'></e-column>
                                  <e-column field='deliver_mehtod' headerText='交貨方式' width='230'></e-column>
                                  <e-column field='total_pages' headerText='張數合計' width='140' format="N0" textAlign="Right" ></e-column>                                                                                 
                                  <e-column field='create_date' headerText='建檔日期' width='180'></e-column>
                                  <e-column field='create_id' headerText='建檔人員' width='140'></e-column>
                                  <e-column field='modify_date' headerText='異動日期' width='180'></e-column>
                                  <e-column field='modify_id' headerText='異動人員' width='140'></e-column>
                                </e-columns>                              
                            </ejs-grid>
                        </ejs-tooltip>
                    </div>
                </div>
            </CCol>
            <div class="dialog">
                <div class="control-section">
                    <ejs-dialog ref="modalDialog" :showCloseIcon='true' :isModal='true' :closeOnEscape='true' :visible='false' :header='e_isAdd ? "新增標籤出貨單" : "修改標籤出貨單"' :buttons='e_buttons' 
                        width='50%'>
                        <div formGroup="orderForm">                       
                            <div class="form-row">            
                                <div class="form-group col-md-4">
                                  <span class="about-title-verify">出貨單號</span>
                                  <ejs-textbox floatLabelType="Always" v-model="e_bill_id" :enabled="e_isAdd" aria-required="true"></ejs-textbox>                              
                                </div>                                
                                <div class="form-group col-md-4">
                                  <span class="about-title-verify">出貨日期</span>
                                  <ejs-datepicker id="datepicker" v-model="e_bill_date" format="yyyy-MM-dd" :enabled="e_isAdd || e_check_id == null"></ejs-datepicker>                                
                                </div>
                                 <div class="form-group col-md-4">
                                  <span class="about-title">來源單號</span>
                                  <ejs-textbox floatLabelType="Always" v-model="e_source_bill_id" :enabled="e_isAdd" aria-required="true"></ejs-textbox>    
                                </div>                                  
                                <div class="form-group col-md-8">
                                  <span class="about-title-verify">企業編號</span>
                                  <ejs-dropdownlist id='enterprise' cssClass="custom-dropdown" :enabled="e_isAdd" :dataSource='enterprise_datas' :select="onEnterpriseSelect" :allowFiltering='true' :fields='fields' v-model="e_enterprise_id" ></ejs-dropdownlist>
                                </div> 
                                <div class="form-group col-md-4"> 
                                  <span class="about-title-verify">出貨倉庫</span> 
                                  <ejs-dropdownlist id='unit' cssClass="custom-dropdown" :enabled="e_isAdd" :dataSource='warehouse_datas' :fields='fields' v-model="e_warehouse_id" ></ejs-dropdownlist>
                                </div>  
                                <div class="form-group col-md-4">
                                  <span class="about-title">聯絡人員</span>
                                  <ejs-textbox floatLabelType="Always" v-model="e_contact"  aria-required="true"  :enabled="e_isAdd || e_check_id == null" ></ejs-textbox>    
                                </div> 
                                <div class="form-group col-md-4">
                                  <span class="about-title">聯絡電話</span>
                                  <ejs-textbox floatLabelType="Always" v-model="e_contact_phone"  aria-required="true" :enabled="e_isAdd || e_check_id == null" ></ejs-textbox>    
                                </div>    
                                <div class="form-group col-md-4">
                                  <span class="about-title">傳真號碼</span>
                                  <ejs-textbox floatLabelType="Always" v-model="e_fax"  aria-required="true"  :enabled="e_isAdd || e_check_id == null" ></ejs-textbox>    
                                </div>  
                                <div class="form-group col-md-2">
                                  <span class="about-title">送貨國碼</span>
                                  <ejs-textbox floatLabelType="Always" v-model="e_deliver_country"  aria-required="true" :enabled="e_isAdd || e_check_id == null" ></ejs-textbox>    
                                </div>                                 
                                <div class="form-group col-md-6">    
                                  <span class="about-title">送貨地址</span>                              
                                  <ejs-textbox floatLabelType="Always" v-model="e_deliver_address"  aria-required="true" :enabled="e_isAdd || e_check_id == null" ></ejs-textbox>    
                                </div>                               
                                <div class="form-group col-md-4">
                                  <span class="about-title">交貨方式</span>
                                  <ejs-textbox floatLabelType="Always" v-model="e_deliver_mehtod"  aria-required="true" :enabled="e_isAdd || e_check_id == null"></ejs-textbox>    
                                </div>                                 
                                <div class="form-group col-md-4">
                                  <span class="about-title-verify">業務人員</span>                               
                                  <ejs-dropdownlist id='sales' cssClass="custom-dropdown"  :dataSource='sales_datas' :fields='fields' v-model="e_bus_person_id" :enabled="e_isAdd || e_check_id == null" ></ejs-dropdownlist>
                                </div>  
                                <div class="form-group col-md-4">
                                  <span class="about-title">標籤啟用期限</span>
                                  <ejs-textbox floatLabelType="Always" format="# 月" v-model="e_enable_months" :enabled="false"></ejs-textbox>    
                                </div>  
                                <div class="form-group col-md-4">
                                  <span class="about-title">標籤啟用年限</span>
                                  <ejs-textbox floatLabelType="Always" v-model="e_service_years" :enabled="false" ></ejs-textbox>    
                                </div>                                
                                <div class="form-group col-md-12">
                                  <span class="about-title">備註</span>
                                  <ejs-textbox floatLabelType="Always" :rows="1" :multiline="true" v-model="e_memo"  :enabled="e_isAdd || e_check_id == null" aria-required="true"></ejs-textbox>    
                                </div>  
                                <div class="form-group col-md-6">                                          
                                </div>    
                                <div class="form-group col-md-6">                                  
                                  <div style="text-align: right; padding-top: 8px;">  
                                    <ejs-button :isPrimary="true" v-show="e_isAdd" v-on:click.native='onLoadOrderToShip'>訂單轉出貨</ejs-button>&nbsp;                                    
                                    <ejs-button :isPrimary="true" v-show="!e_isAdd && e_check_id == null" v-on:click.native='onLoadCheck'>營運覆核</ejs-button>&nbsp;        
                                    <!--<ejs-button :isPrimary="true" v-show="!e_isAdd && e_check_id != null" v-on:click.native='onUnLoadCheck'>取消營運覆核</ejs-button>&nbsp;      -->                   
                                  </div>            
                                </div>    
                                <div class="form-group col-md-12">       
                                      
                                  <ejs-tooltip ref="tooltip" target=".e-rowcell" >              
                                    <ejs-grid ref='ref_contact_data' :dataSource='contact_datas' height='150' :allowExcelExport='true' :allowPaging='false' :allowSorting='false' :allowFiltering='false' :allowReordering='false'
                                      :toolbar='toolbarContact' :pageSettings='pageSettings' :filterSettings='filterSettings' :selectionSettings='selectionSettings' 
                                      :editSettings='editContactSettings' :beforeRender="beforeRender" :toolbarClick="toolbarClick"
                                      :queryCellInfo='onQueryCellInfo' :rowDataBound="onRowDataBound" :actionComplete="onActionComplete" >
                                      <e-columns>                   
                                        <e-column field='row_id' headerText='序號' aria-required="true" width='80' :allowEditing='false'></e-column>                                   
                                        <e-column field='style_id' headerText='款式名稱' editType='dropdownedit'  width='220' :defaultValue="e_style_id" :edit='labstyleParams' :template="lbStyleTemplate" :allowEditing='false'></e-column>     
                                        <e-column field='start_label_no' headerText='標籤起始序號' width='160' :allowEditing='false'></e-column>      
                                        <e-column field='end_label_no' headerText='標籤結束序號' width='160'  :allowEditing='false' ></e-column>        
                                        <e-column field='volume_no' headerText='出貨捲號' width='160'  :allowEditing='false' ></e-column>       
                                        <e-column field='volumes' headerText='出貨卷數' width='160'  :allowEditing='false' ></e-column>                       
                                        <e-column field='pages' headerText='張數' width='120' format="N0" :allowEditing='false' textAlign="Right"  ></e-column>                 
                                        <e-column field='bad_pages' headerText='排除張數' width='120' format="N0" :allowEditing='false' textAlign="Right"  ></e-column>    
                                        <e-column field='real_pages' headerText='出貨張數' width='120' format="N0" :allowEditing='false' textAlign="Right"  ></e-column>    
                                        <e-column field='is_gift' headerText='贈品' editType='dropdownedit'  width='120' :defaultValue="false"  :edit='yesNoParams' :template="isGiftTemplate"></e-column> 
                                        <e-column field='memo' headerText='備註' width='220' textAlign="Right"  ></e-column>    
                                        <e-column field='order_sub_id' headerText='訂單序號' width='120' format="N0" :allowEditing='false' textAlign="Right"  ></e-column>    
                                        <e-column field='enable_date' format="yyyy-MM-dd" type="date" headerText='啟用期限' width='120' :allowEditing='false' textAlign="Right"  ></e-column>    
                                        <e-column field='create_date' format="yyyy-MM-dd" type="date" headerText='建檔日期' width='120' :allowEditing='false' textAlign="Right"  ></e-column>    
                                        <e-column field='create_id' headerText='建檔人員' width='120' :allowEditing='false' textAlign="Right"  ></e-column>  
                                      </e-columns>
                                    </ejs-grid>
                                  </ejs-tooltip>
                              </div> 
                            </div>
                        </div>                
                    </ejs-dialog>
                </div>    
            </div>
            <div class="dialog2">
                <div class="control-section">
                    <ejs-dialog ref="modalDialog2" :showCloseIcon='true' :isModal='true' :closeOnEscape='true' :visible='false' header='訂單轉銷貨' :buttons='e_buttons_load_production' 
                        width='50%'>
                        <div formGroup="orderForm">                            
                            <div class="form-row">       
                                <div class="form-group col-md-6">    
                                  <span class="about-title-verify">訂單單號</span>               
                                  <ejs-textbox floatLabelType="Always" v-model="e_o_bill_id"  v-on:click.native='onOrderLabel'  aria-required="true" :enabled="true" ></ejs-textbox> 
                                </div>          
                                <div class="form-group col-md-2">    
                                  <span class="about-title">訂購日期</span>                              
                                  <ejs-textbox floatLabelType="Always" v-model="e_o_bill_date"  aria-required="true" :enabled="false" ></ejs-textbox>    
                                </div>  
                                <div class="form-group col-md-2">    
                                  <span class="about-title">序號</span>                              
                                  <ejs-textbox floatLabelType="Always" v-model="e_o_no"  aria-required="true" :enabled="false" ></ejs-textbox>    
                                </div>   
                                <div class="form-group col-md-2">    
                                  <span class="about-title">未出卷數</span>                              
                                  <ejs-textbox floatLabelType="Always" v-model="e_o_volumes"  aria-required="true" :enabled="false" ></ejs-textbox>    
                                </div>    
                                <div class="form-group col-md-4">    
                                  <span class="about-title">款式編號</span>                              
                                  <ejs-textbox floatLabelType="Always" v-model="e_o_style_id"  aria-required="true" :enabled="false" ></ejs-textbox>    
                                </div>  
                                <div class="form-group col-md-8">    
                                  <span class="about-title">款式名稱</span>                              
                                  <ejs-textbox floatLabelType="Always" v-model="e_o_style_name"  aria-required="true" :enabled="false" ></ejs-textbox>    
                                </div> 
                                <div class="form-group col-md-6">    
                                  <span class="about-title-verify">標籤卷數編號(起)</span>                              
                                  <ejs-textbox floatLabelType="Always" v-model="e_o_start_label"  v-on:click.native='onStartLabel' aria-required="true" :enabled="e_isAdd" ></ejs-textbox>    
                                </div> 
                                <div class="form-group col-md-6">    
                                  <span class="about-title-verify">標籤卷數編號(迄)</span>                              
                                  <ejs-textbox floatLabelType="Always" v-model="e_o_end_label" v-on:click.native='onEndLabel' aria-required="true" :enabled="e_isAdd" ></ejs-textbox>    
                                </div>                   
                                <div class="form-group col-md-12">               
                                  <ejs-tooltip ref="tooltip" target=".e-rowcell" >
                                    <ejs-grid ref='ref_contact_data' :dataSource='order_to_ship_volume_datas' height='20vh' :allowExcelExport='true' :allowPaging='true' :allowSorting='true' :allowFiltering='true' :allowReordering='true'
                                      :toolbar='toolbarContact2' :pageSettings='pageSettings' :filterSettings='filterSettings' :selectionSettings='selectionSettings' :toolbarClick="toolbarClick"
                                      :editSettings='editSettings2' :beforeRender="beforeRender"
                                      :queryCellInfo='onQueryCellInfo' :rowDataBound="onRowDataBound" >
                                      <e-columns> 
                                        <e-column field='no' headerText='序號' aria-required="true" :isPrimaryKey='true' width='110'></e-column>
                                        <e-column field='get_volume' headerText='取用卷號' editType='numericedit' format="N0" width='140' :edit="{params: { min: 0, decimals: 1 }}"></e-column>
                                        <e-column field='start_label_no' headerText='標籤起始卷號' aria-required="true" :isPrimaryKey='true' width='180' ></e-column>
                                        <e-column field='end_label_no' headerText='標籤結束卷號' aria-required="true" :isPrimaryKey='true' width='180'></e-column>
                                        <e-column field='volume_no' headerText='標籤卷號' aria-required="true" :isPrimaryKey='true' width='180'></e-column>
                                        <e-column field='volumes' headerText='卷數' aria-required="true" :isPrimaryKey='true' width='110'></e-column>
                                        <e-column field='pages' headerText='張數' aria-required="true" format="N0" textAlign="Right" :isPrimaryKey='true' width='110'></e-column>
                                        <e-column field='bad_pages' headerText='排除張數' aria-required="true" format="N0" textAlign="Right" :isPrimaryKey='true' width='140'></e-column>
                                        <e-column field='real_pages' headerText='實際張數' aria-required="true" format="N0" textAlign="Right" :isPrimaryKey='true' width='140'></e-column>
                                        <e-column field='bill_id' headerText='來原單號' aria-required="true" :isPrimaryKey='true' width='180'></e-column>
                                      </e-columns>                              
                                    </ejs-grid>
                                  </ejs-tooltip>
                              </div> 
                            </div>
                        </div>                
                    </ejs-dialog>
                </div>    
            </div>
             <div class="dialog3">
                <div class="control-section">
                    <ejs-dialog ref="modalDialog3" :showCloseIcon='true' :isModal='true' :closeOnEscape='true' :visible='false' header='訂單轉銷貨' :buttons='e_buttons_load_order_to_ship' 
                        width='50%'>
                        <div formGroup="orderForm">                            
                            <div class="form-row">    
                                <div class="form-group col-md-12">                
                                  <ejs-tooltip ref="tooltip" target=".e-rowcell" >
                                    <ejs-grid ref='refOrderToShipData' :dataSource='order_to_ship_datas' height='45vh' :allowExcelExport='true' :allowPaging='true' :allowSorting='true' :allowFiltering='true' :allowReordering='true'
                                      :toolbar='toolbarOrderToShip' :pageSettings='pageSettings' :filterSettings='filterSettings' :selectionSettings='selectionSettings' :toolbarClick="toolbarClick" :rowSelected='rowOrderToShipSelected' 
                                      :editSettings='editSettings' :beforeRender="beforeRender" :queryCellInfo='onQueryCellInfo' :rowDataBound="onRowDataBound" >
                                      <e-columns>                   
                                        <e-column field='bill_id' headerText='訂單單號' aria-required="true" :isPrimaryKey='true' width='180'></e-column>
                                        <e-column field='bill_date'  format="yyyy-MM-dd" type="date" headerText='訂單日期' width='140'></e-column>          
                                        <e-column field='customer_po' headerText='客戶PO' width='160'></e-column>          
                                        <e-column field='enterprise_id' headerText='企業編號' width='140'></e-column>   
                                        <e-column field='enterprise_name' headerText='企業名稱' width='200'></e-column>       
                                        <e-column field='deliver_country' headerText='送貨國家' width='140'></e-column>  
                                        <e-column field='deliver_address' headerText='送貨地址' width='280'></e-column>  
                                        <e-column field='row_id' headerText='訂單序號' width='140'></e-column>  
                                        <e-column field='style_id' headerText='款式編號' width='140'></e-column>  
                                        <e-column field='style_name' headerText='款式名稱' width='200'></e-column>  
                                        <e-column field='pages' headerText='張數' width='140' format="N0" textAlign="Right" ></e-column>  
                                        <e-column field='is_gift' headerText='贈品' width='140'></e-column>  
                                        <e-column field='cancel_pages' headerText='取消張數' format="N0" textAlign="Right" width='140'></e-column>  
                                        <e-column field='no_deliver_pages' headerText='未出貨張數' format="N0" textAlign="Right" width='140'></e-column>    
                                        <e-column field='is_close' headerText='結案' width='140'></e-column>  
                                        <e-column field='is_estimate' headerText='估算' width='140'></e-column>  
                                        <e-column field='pre_deliver_date' headerText='預交日期' width='140'></e-column>  
                                        <e-column field='bill_date' headerText='原預交日期' width='140'></e-column>  
                                        <e-column field='memo' headerText='備註' width='140'></e-column>  
                                        <e-column field='no_deliver_volumes' headerText='未出卷數' format="N0" textAlign="Right" width='140'></e-column>  
                                        <e-column field='service_years' headerText='標籤使用年限' format="N0" textAlign="Right" width='140'></e-column>  
                                        <e-column field='enable_months' headerText='標籤起始年限' format="N0" textAlign="Right" width='140'></e-column>  
                                      </e-columns>                              
                                    </ejs-grid>
                                  </ejs-tooltip>
                              </div> 
                            </div>
                        </div>                
                    </ejs-dialog>
                </div>    
            </div>

              <div class="dialog4">
                <div class="control-section">
                    <ejs-dialog ref="modalDialog4" :showCloseIcon='true' :isModal='true' :closeOnEscape='true' :visible='false' header='庫存標籤卷轉入銷貨' :buttons='e_buttons_load_bill' 
                        width='50%'>
                        <div formGroup="orderForm">                            
                            <div class="form-row">    
                                <div class="form-group col-md-12">                
                                  <ejs-tooltip ref="tooltip" target=".e-rowcell" >
                                    <ejs-grid ref='refBillata' :dataSource='order_bill_datas' height='45vh' :allowExcelExport='true' :allowPaging='true' :allowSorting='true' :allowFiltering='true' :allowReordering='true'
                                      :toolbar='toolbarBill' :pageSettings='pageSettings' :filterSettings='filterSettings' :selectionSettings='selectionSettings' :toolbarClick="toolbarClick" :rowSelected='rowBillSelected' 
                                      :editSettings='editSettings' :beforeRender="beforeRender" :queryCellInfo='onQueryCellInfo' :rowDataBound="onRowDataBound" >
                                      <e-columns>                   
                                        <e-column field='style_id' headerText='款式編號' aria-required="true" :isPrimaryKey='true' width='140'></e-column>
                                        <e-column field='style_name' headerText='款式名稱' aria-required="true" :isPrimaryKey='true' width='180'></e-column>
                                        <e-column field='volume_no' headerText='標籤捲編號' aria-required="true" :isPrimaryKey='true' width='180'></e-column>
                                        <e-column field='start_label_no' headerText='標籤起始序號' aria-required="true" :isPrimaryKey='true' width='180'></e-column>
                                        <e-column field='end_label_no' headerText='標籤結束序號' aria-required="true" :isPrimaryKey='true' width='180'></e-column>
                                        <e-column field='pages' headerText='張數'  format="N0" textAlign="Right" aria-required="true" :isPrimaryKey='true' width='180'></e-column>
                                        <e-column field='bad_pages' headerText='排除張數' aria-required="true"  format="N0" textAlign="Right" :isPrimaryKey='true' width='180'></e-column>
                                        <e-column field='real_pages' headerText='出貨張數' aria-required="true" format="N0" textAlign="Right" width='180'></e-column>
                                        <e-column field='bill_id' headerText='出貨單號' aria-required="true" :isPrimaryKey='true' width='180'></e-column>
                                      </e-columns>                              
                                    </ejs-grid>
                                  </ejs-tooltip>
                              </div> 
                            </div>
                        </div>                
                    </ejs-dialog>
                </div>    
            </div>
            <ejs-toast ref='toastRef' id='toast_type' :position='position'></ejs-toast>      
        </CCardBody>
    </CCard>  
</template>



<style lang="scss" src="../../scss/grid.scss"></style>
<script>

import Vue from "vue";
import { Query } from '@syncfusion/ej2-data';
import Loading from 'vue-loading-overlay';
import { DialogUtility } from '@syncfusion/ej2-popups';
import { ButtonComponent } from "@syncfusion/ej2-vue-buttons";
import { ToastComponent } from "@syncfusion/ej2-vue-notifications";
import { DatePickerComponent } from "@syncfusion/ej2-vue-calendars";
import { L10n, setCulture, enableRipple } from '@syncfusion/ej2-base';
import { DialogPlugin, TooltipPlugin } from '@syncfusion/ej2-vue-popups';
import { GridComponent, ColumnDirective, ColumnsDirective, GridPlugin, DetailRow, PdfExport, ExcelExport, Sort, Edit, Page, Filter, Reorder, Toolbar, Search } from "@syncfusion/ej2-vue-grids";
import { DropDownListComponent } from '@syncfusion/ej2-vue-dropdowns';


setCulture('en-US');
L10n.load({
  'en-US': {
    'pager': {
      'currentPageInfo': '',
      'totalItemsInfo': '{1} to {2} of {0}',
    },
    'grid': {
      'Print': '列印',
      'Search': '搜尋',
      'Add': '新增',
      'Edit' : '修改',
      'Delete' : '刪除',
      'Update' : '確認',
      'Cancel' : '取消'
    }
  }
});

enableRipple(true);
Vue.use(DialogPlugin);
Vue.use(TooltipPlugin);
Vue.use(GridPlugin);
Vue.use(Loading);

let DialogObj   = undefined;
let Loader      = undefined;


export default {
  name: 'Department',
  components: {   
    'ejs-button': ButtonComponent,
    'ejs-toast': ToastComponent,
    'ejs-datepicker': DatePickerComponent,
    'ejs-grid': GridComponent,
    'e-column': ColumnDirective,
    'e-columns': ColumnsDirective,
    'ejs-dropdownlist': DropDownListComponent
  },
  data: function () {
    return {
      e_selectRow : null, e_selectData: null, e_selectProductionData: null,
      e_OrderToShipSelectRow : null, e_OrderToShipSelectData : null,
      e_BillSelectRow : null, e_BillSelectData : null,    
      e_BillStartSelectData : null, e_BillEndSelectData : null,  

      e_isAdd: null, 
      e_style_id: null, e_style_name: null, e_style_page: null, e_total_pages: 0, 
      e_bill_id: null, e_bill_date: null, e_enterprise_id: null, e_warehouse_id: null,
      e_contact : null, e_contact_phone : null, e_fax : null, e_deliver_mehtod  : null, e_deliver_country : null, e_deliver_address: null, e_memo: null, 
      e_enable_months: null, e_service_years: null,   e_source_bill_id : null, e_bus_person_id: null, e_check_id: null,
      e_is_start_label: null,
      e_o_bill_id : null, e_o_bill_date : null, e_o_no : null, e_o_volumes : null, e_o_style_id : null, e_o_style_name : null, e_o_start_label : null, e_o_end_label : null,
      
      e_buttons: [
        {click: this.editOkClick, buttonModel: { content: '確認'} }, 
        {click: function() { this.hide(); },buttonModel: { content: '取消'}}
      ],
      e_buttons_load_production: [
        {click: this.editProductionOkClick, buttonModel: { content: '確認' } }, 
        {click: function() { this.hide(); },buttonModel: { content: '取消'}}
      ],
      e_buttons_load_order_to_ship: [
        {click: this.editOrderToShipOkClick, buttonModel: { content: '確認' } }, 
        {click: function() { this.hide(); },buttonModel: { content: '取消'}}
      ],
      e_buttons_load_bill: [
        {click: this.editBillOkClick, buttonModel: { content: '確認',  } }, 
        {click: function() { this.hide(); },buttonModel: { content: '取消'}}
      ],   
   
      filterSettings: { type: 'CheckBox' },
      pageSettings: { pageSize: 15, pageSizes: [10, 50, 100, 200], pageCount: 4 },
      selectionSettings: { persistSelection: true },
      editSettings: { allowEditing: false, allowAdding: false, allowDeleting: false, showAddNewRow: false },
      editSettings2: { allowEditing: true, allowAdding: false, allowDeleting: true, showAddNewRow: false },
      editContactSettings: { allowEditing: true, allowAdding: false, allowDeleting: false, showAddNewRow: false },
      toolbar: null,
      toolbarContact: [   
        { text: '匯出', tooltipText: '匯出', prefixIcon: 'e-btn-icon e-excelexport e-icons e-icon-left', id: 'BadListExport' }, 
        'Update', 'Cancel',
        'Search',
        'Print'
      ],
      toolbarContact2: [
        { text: '查詢', tooltipText: '查詢', prefixIcon: 'e-btn-icon e-search e-icons e-icon-left', id: 'OrderToShipSearch' }, 
        { text: '匯出', tooltipText: '匯出', prefixIcon: 'e-btn-icon e-excelexport e-icons e-icon-left', id: 'BadListExport' }, 
        'Update', 'Cancel',
        'Search',
        'Print'
      ],
      toolbarOrderToShip: [
        { text: '匯出', tooltipText: '匯出', prefixIcon: 'e-btn-icon e-excelexport e-icons e-icon-left', id: 'OrderToShipExport' }, 
        'Search',
        'Print'
      ],
      toolbarBill: [      
        { text: '匯出', tooltipText: '匯出', prefixIcon: 'e-btn-icon e-excelexport e-icons e-icon-left', id: 'OrderToShipExport' }, 
        'Search',
        'Print'
      ],

      datas:  [], enterprise_datas:[], warehouse_datas:  [], sales_datas:  [], contact_datas: [], order_to_ship_datas: [], order_to_ship_volume_datas: [], order_bill_datas: [],
      position: { X: 'Right', Y: "Bottom" }, ShowBtn: false,
      fields: { value: 'value', text: 'text'},     
      ofields: { value: 'bill_id', text: 'bill_id'},     
      yesNoParams : {
        params: {
          allowFiltering: true,
          dataSource: [{ value: true, text: '是' }, { value: false, text: '否' }],
          query: new Query(),
          fields: { value: 'value', text: 'text'},         
        },
      },
      labstyleParams : null,
      lbStyleTemplate: function () { return { 
          template: Vue.component("lbStyleTemplate", {
          template:  `<div>{{name}}</div>`,
              data: function () { return { data: {}, usermale: 'usermale', userfemale: 'userfemale' }; },
          computed: {
              name: function() {
                  return `${this.data.style_id} ${this.data.style_name}`;
              }
          }
      })}},    
      isGiftTemplate: function () { return { 
          template: Vue.component("isGiftTemplate", {
          template:  `<div>{{name}}</div>`,             
          computed: {
              name: function() {
                  return this.data.is_gift ? "是" : "否";
              }
          }
      })}},
      isEstimateTemplate: function () { return { 
          template: Vue.component("isEstimateTemplate", {
          template:  `<div>{{name}}</div>`,              
          computed: {
              name: function() {
                  return this.data.is_estimate ? "是" : "否";
              }
          }
      })}},
      isCloseTemplate: function () { return { 
          template: Vue.component("isCloseTemplate", {
          template:  `<div>{{name}}</div>`,            
          computed: {
              name: function() {
                  return this.data.is_close ? "是" : "否";
              }
          }
      })}},
      dateTemplate: function () { return { 
          template: Vue.component("dateTemplate", {
          template:  `<div>{{name}}</div>`,            
          computed: {
              name: function() {
                  return this.pre_deliver_date.toISOString().split('T')[0]
              }
          }
      })}},
      
    };
  },
  methods: {    
    toolbarClick: function (args) {     
      if (args.item.id == 'Delete') {
        DialogObj = DialogUtility.confirm({
            title: '刪除資料',
            content: `確認是否要刪除出貨單號${this.e_selectData.bill_id}的資料嗎?`,
            okButton: {  text: '是', click: this.delOkClick },
            cancelButton: {  text: '否', click: this.delCancelClick },
            showCloseIcon: true,
            closeOnEscape: true,
            animationSettings: { effect: 'Fade' }
        });
      }
      if (args.item.id == 'Add') {         
        this.e_isAdd = true;
        this.e_bill_date  = new Date();
        this.e_bill_id = "";    
        this.e_enterprise_id = null;
        this.e_contact= ""; 
        this.e_contact_phone= ""; 
        this.e_warehouse_id = null;
        this.e_fax = ""; 
        this.e_deliver_mehtod = ""; 
        this.e_deliver_country = ""; 
        this.e_deliver_address = ""; 
        this.e_memo = ""; 
        this.e_enable_months = ""; 
        this.e_service_years = ""; 
        this.e_source_bill_id = ""; 
        this.e_check_id = null;
        this.e_bus_person_id = null;   
        this.contact_datas = [];
        this.getNumber();
        this.$refs.modalDialog.show();    
      }
      if (args.item.id == 'Edit') {
        this.recordDoubleClick(); 
      }
      if (args.item.id == "Export") {
        this.$refs.refdata.excelExport({ fileName:'標籤訂購單.xlsx' });
      }   
      if (args.item.id == "OrderToShipExport") {
        this.$refs.refOrderToShipData.excelExport({ fileName:'訂單轉銷貨.xlsx' });
      }   
      if (args.item.id == "PrintOnly") {     

        fetch(this.e_selectData.report_url, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        })
          .then(res => res.blob())
          .then(blob => {
            const url = URL.createObjectURL(blob);
            window.open(url, "_blank"); // 用 Blob URL 開新頁
          });
      }
      if (args.item.id == "OrderToShipSearch") {  
        this.onGetBillList();
      }
      if (args.item.id == "Refresh") {  
        this.getLBDeliverMain();
      }
      if (args.item.id == "Send") {  
        this.putReSend();
      }
      
    },   
    onActionComplete(args) {
      console.log(args.requestType);
      if (args.requestType === 'save') {
        let idx = this.contact_datas.findIndex(x => x.id === args.data.id);
        if (idx !== -1) {
          this.contact_datas.splice(idx, 1, args.data); // 更新
        }
      } else if (args.requestType === 'delete') {
        this.contact_datas = this.contact_datas.filter(x => x.id !== args.data[0].id);
      }
    },
    onLoadOrderToShip: function() {
      if (this.e_enterprise_id === null) {
        this.showMsg('請先選擇企業資料!');           
        return;
      }
       if (this.e_warehouse_id === null) {
        this.showMsg('請先選擇出貨倉庫!');           
        return;
      }
      this.getOrderToShipUse();
      // this.$refs.modalDialog.hide();    
      this.$refs.modalDialog2.show();    
    },
    operationsOkClick: function() {
      DialogObj.hide();
      this.showLoading();   
      this.axios({
        method: 'post',
        baseURL: Vue.prototype.GLOBAL.baseURL,
        url: 'LBDeliver/Check',
        headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
        data : {        
          bill_id: this.e_bill_id
        }
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; } 
        this.showMsg('覆核成功!');     
        this.$refs.modalDialog.hide();    
        this.hideLoading();
        this.getLBDeliverMain();       
      })
      .catch((error) => { this.showError(error, true) }
      )      
    },
    onLoadCheck: function() {
      DialogObj = DialogUtility.confirm({
          title: '刪除資料',
          content: `確認是否要營運覆核嗎?`,
          okButton: {  text: '是', click: this.operationsOkClick },
          cancelButton: {  text: '否', click: this.delCancelClick },
          showCloseIcon: true,
          closeOnEscape: true,
          animationSettings: { effect: 'Fade' }
      });

    },
    onUnLoadCheck: function() {

      this.showLoading();   
      this.axios({
        method: 'post',
        baseURL: Vue.prototype.GLOBAL.baseURL,
        url: 'LBDeliver/UnCheck',
        headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
        data : {        
          bill_id: this.e_bill_id
        }
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; } 
        this.showMsg('取消覆核成功!');     
        this.$refs.modalDialog.hide();    
        this.hideLoading();
        this.getLBDeliverMain();       
      })
      .catch((error) => { this.showError(error, true) }
      )      

      console.log(this.e_bill_id);
    },
   
   
    onStartLabel() {
    
      if (this.e_o_style_id === null) {
        this.showMsg('標籤編號不得為空!');           
        return;
      }
      this.e_is_start_label = true;
      this.e_BillSelectRow = null;
      this.e_BillSelectData = null;
      this.$refs.modalDialog4.show();  
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `/LBStock/Bill?style_id=${this.e_o_style_id}&warehourse_id=${this.e_warehouse_id}`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }              
        this.order_bill_datas = response.data.datas;
      })
      .catch((error) => { this.showError(error, true) }
      )     
      
    },
    onEndLabel() {
      if (this.e_o_style_id === null) {
        this.showMsg('標籤編號不得為空!');           
        return;
      }
      this.e_is_start_label = false;
      this.e_BillSelectRow = null;
      this.e_BillSelectData = null;
      this.$refs.modalDialog4.show();  
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `/LBStock/Bill?style_id=${this.e_o_style_id}&warehourse_id=${this.e_warehouse_id}`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }              
        this.order_bill_datas = response.data.datas;
      })
      .catch((error) => { this.showError(error, true) }
      )     
      
    },
    onOrderLabel() {
      this.$refs.modalDialog3.show();    
    },
    onGetBillList() {
      if (this.e_o_style_id === null) {
        this.showMsg('標籤編號不得為空!');           
        return;
      }
      if (this.e_o_start_label === null || this.e_o_end_label === null ) {
        this.showMsg('請先選擇標籤起訖!');           
        return;
      }
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `/LBStock/BillList?style_id=${this.e_o_style_id}&warehourse_id=${this.e_warehouse_id}&start_volume=${this.e_o_start_label}&end_volume=${this.e_o_end_label}`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }              
   
        this.order_to_ship_volume_datas = response.data.datas;
      })
      .catch((error) => { this.showError(error, true) }
      )     

    },
    onQueryCellInfo(args) {     
      if (args.cell) {
        args.cell.classList.add("tooltip-cell");
        args.cell.setAttribute("title", `${args.column.headerText}: ${args.data[args.column.field]}`);
      }
    },
    onRowDataBound(args) {
      if (args.data.state == 2) {
        args.row.style.backgroundColor = "rgba(255, 229, 255, 0.8)"; // 數量少於 3，淡紅色
      } 
    },     
    checkHeader: function() {
      console.log(this.e_selectData);
      if (this.e_selectRow == undefined) {
        this.toolbar =  [
          { text: '新增', tooltipText: '新增', prefixIcon: 'e-btn-icon e-add e-icons e-icon-left', id: 'Add' , disabled: false },
          { text: '修改', tooltipText: '修改', prefixIcon: 'e-btn-icon e-edit e-icons e-icon-left', id: 'Edit', disabled: this.e_selectRow == undefined || this.e_check_id != null },
          { text: '刪除', tooltipText: '刪除', prefixIcon: 'e-btn-icon e-delete e-icons e-icon-left', id: 'Delete', disabled: this.e_selectRow == undefined || this.e_check_id != null },  
          { text: '重新送至全鏈路', tooltipText: '重新送至全鏈路', prefixIcon: 'e-btn-icon e-refresh e-icons e-icon-left', id: 'Send', disabled: true },  
          { text: '重整', tooltipText: '重整', prefixIcon: 'e-btn-icon e-refresh e-icons e-icon-left', id: 'Refresh' },   
          { text: '匯出', tooltipText: '匯出', prefixIcon: 'e-btn-icon e-excelexport e-icons e-icon-left', id: 'Export' }, 
        // { text: '單筆列印', tooltipText: '單筆列印', prefixIcon: 'e-btn-icon e-print e-icons e-icon-left', id: 'PrintOnly' }, 
          'Print', 'Search'];
      } else {
        this.toolbar =  [
          { text: '新增', tooltipText: '新增', prefixIcon: 'e-btn-icon e-add e-icons e-icon-left', id: 'Add' , disabled: false },
          { text: '修改', tooltipText: '修改', prefixIcon: 'e-btn-icon e-edit e-icons e-icon-left', id: 'Edit', disabled: this.e_selectRow == undefined || this.e_check_id != null },
          { text: '刪除', tooltipText: '刪除', prefixIcon: 'e-btn-icon e-delete e-icons e-icon-left', id: 'Delete', disabled: this.e_selectRow == undefined || this.e_check_id != null },   
          { text: '重新送至全鏈路', tooltipText: '重新送至全鏈路', prefixIcon: 'e-btn-icon e-refresh e-icons e-icon-left', id: 'Send', disabled: this.e_selectData.bill_status != '送至全鏈路失敗' },
          { text: '重整', tooltipText: '重整', prefixIcon: 'e-btn-icon e-refresh e-icons e-icon-left', id: 'Refresh' },      
          { text: '匯出', tooltipText: '匯出', prefixIcon: 'e-btn-icon e-excelexport e-icons e-icon-left', id: 'Export' }, 
        // { text: '單筆列印', tooltipText: '單筆列印', prefixIcon: 'e-btn-icon e-print e-icons e-icon-left', id: 'PrintOnly' }, 
          'Print', 'Search'];
      }
    
    },
    getLBStyle: function () {        
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `/LBStyle/Dropdown`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }              
        this.e_style_id = response.data.datas[0].value;
        this.e_style_name = response.data.datas[0].text.replace(response.data.datas[0].value, "").trim();
        this.e_style_page = response.data.datas[0].number;
        this.labstyleParams = {
          params: {
            allowFiltering: true,
            dataSource:  response.data.datas ,
            query: new Query(),
            fields: { value: 'value', text: 'text', number: 'number'},   
            select: (args) => {
              const formEle = this.$refs.ref_contact_data.$el.ej2_instances['0'].element.querySelector('form')['ej2_instances'][0];
              formEle.getInputElement('pages').value = args.itemData.number * formEle.getInputElement('volumes').value;
              formEle.getInputElement('style_pages').value = args.itemData.number
              formEle.getInputElement('style_name').value = args.itemData.text.replace(args.itemData.value, "").trim();
            },
            change: () => {
              
            },      
          },
        };
      })
      .catch((error) => { this.showError(error, true) }
      )               
    },
   
    rowSelected: function(args) {    
      this.e_selectRow = args.row.getAttribute('aria-rowindex');     
      this.e_selectData = args.data; 
      this.e_check_id = this.e_selectData.check_id;
      this.getStockSub(args.data.bill_id);
      this.checkHeader();
    },
    rowOrderToShipSelected: function(args) {    
      this.e_OrderToShipSelectRow = args.row.getAttribute('aria-rowindex');     
      this.e_OrderToShipSelectData = args.data; 
    },
    rowBillSelected: function(args) {    
      this.e_BillSelectRow = args.row.getAttribute('aria-rowindex');     
      this.e_BillSelectData = args.data; 
    },
    delOkClick: function() {
      DialogObj.hide();
      this.showLoading();
      this.axios({
          method: 'delete',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: 'LBDeliver',
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          data : {
            bill_id: this.e_selectData.bill_id
          }
      })
      .then((response) => {       
        this.hideLoading();
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; } 
        this.showMsg('刪除成功!');              
        this.getLBDeliverMain();       
      })
      .catch((error) => { this.showError(error, true) }
      ) 
    },   
    delCancelClick: function() {
       this.showMsg(this.e_isAdd ? '新增成功!' : '修改成功!');     
       DialogObj.hide();
    },      
    editOrderToShipOkClick: function() { 
       if (this.e_OrderToShipSelectRow == null) {
        this.$refs.toastRef.show( { title: '錯誤!', content: '請先選擇一筆訂單資料', cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); 
        return;
       }
       
       this.e_o_bill_id = this.e_OrderToShipSelectData.bill_id;
       this.e_o_bill_date = this.e_OrderToShipSelectData.bill_date;
       this.e_o_no = this.e_OrderToShipSelectData.row_id;
       this.e_o_volumes = this.e_OrderToShipSelectData.no_deliver_volumes;
       this.e_o_style_id = this.e_OrderToShipSelectData.style_id;
       this.e_o_style_name = this.e_OrderToShipSelectData.style_name;
       this.$refs.modalDialog3.hide();    
    },
    editBillOkClick: function() { 
       if (this.e_BillSelectRow == null) {
        this.$refs.toastRef.show( { title: '錯誤!', content: '請先選擇一筆訂單資料', cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); 
        return;
       }       
       if (this.e_is_start_label == true) {
         this.e_BillStartSelectData = this.e_BillSelectData;
         this.e_o_start_label =  this.e_BillSelectData.volume_no;
       }
       if (this.e_is_start_label == false) {
         this.e_BillEndSelectData = this.e_BillSelectData;
         this.e_o_end_label =  this.e_BillSelectData.volume_no;
       }
       this.$refs.modalDialog4.hide();    
    },
    getCurrentDate: function() {
      let now = new Date();
      return `${now.getFullYear()}-${this.pad(now.getMonth()+1)}-${this.pad(now.getDate())}`;
    },
    pad:function(n) {
      return n.toString().padStart(2, '0');
    },
    editProductionOkClick: function() {  

      if (this.e_o_bill_id == null) {
        this.$refs.toastRef.show( { title: '警告!', content: '請先選擇訂單單號' , cssClass: 'e-toast-warning', icon: 'e-warning toast-icons' });           
        return;
      }
      if (this.e_o_start_label == null) {
        this.$refs.toastRef.show( { title: '警告!', content: '請先選擇標籤卷數編號(起)' , cssClass: 'e-toast-warning', icon: 'e-warning toast-icons' });           
        return;
      }
      if (this.e_o_end_label == null) {
        this.$refs.toastRef.show( { title: '警告!', content: '請先選擇標籤卷數編號(迄)' , cssClass: 'e-toast-warning', icon: 'e-warning toast-icons' });           
        return;
      }

      this.contact_datas = [];
      this.e_total_pages = 0;
      this.e_source_bill_id = this.e_o_bill_id;
      
      for (let i = 0; i < this.order_to_ship_volume_datas.length; i++) {
        let element = this.order_to_ship_volume_datas[i];       
        if (element.get_volume == 0) {
          this.$refs.toastRef.show( { title: '警告!', content: '請設定取用捲號' , cssClass: 'e-toast-warning', icon: 'e-warning toast-icons' });           
          return;
        }
        if (element.get_volume > 0) {    

          this.e_total_pages = this.e_total_pages +  element.pages;
          this.contact_datas.push(
          {
            "bill_id" : element.bill_id,
            "bill_date" : this.e_o_bill_date,
            "enterprise_id" : this.e_enterprise_id,
            "bad_pages" : element.bad_pages,
            "del_flag" : false,
            "end_label_no" : element.end_label_no,
            "is_gift" : false,
            "pages" : element.pages,
            "pre_bill_id" : this.e_o_bill_id,
            "pre_bill_type" : 0,
            "real_pages" : this.e_total_pages,
            "row_id" : i + 1,
            "start_label_no" : element.start_label_no,
            "style_id" : this.e_o_style_id,
            "style_name" : this.e_o_style_name,
            "sub_id" : 1,
            "volumes" : element.get_volume,
            "volumes_b" : this.e_o_start_label,
            "volumes_e" : this.e_o_end_label,
            "enable_date" : this.getCurrentDate(),
            "order_bill_id" : this.e_o_bill_id,
            "order_sub_id" : 1,
            "volume_no" : element.volume_no,
            "memo" : "",
            "create_date" : this.getCurrentDate(),
            "create_id" : "admin"
          })
        }       
      }      
      this.$refs.modalDialog2.hide();          
    },
    editOkClick: function() {           
      
      this.showLoading();   
      this.axios({
        method: this.e_isAdd ? 'post' : 'put',
        baseURL: Vue.prototype.GLOBAL.baseURL,
        url: 'LBDeliver',
        headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
        data : {
          main: { 
            bill_id: this.e_bill_id,
            bill_date: this.e_bill_date,           
            enterprise_id: this.e_enterprise_id, 
            warehouse_id: this.e_warehouse_id, 
            source_bill_id: this.e_source_bill_id, 
            contact: this.e_contact, 
            contact_phone: this.e_contact_phone, 
            fax: this.e_fax, 
            deliver_country: this.e_deliver_country, 
            deliver_address: this.e_deliver_address, 
            deliver_mehtod: this.e_deliver_mehtod, 
            bus_person_id: this.e_bus_person_id, 
            total_pages: this.e_total_pages, 
            service_years: this.e_service_years == "" ? 0 : this.e_service_years , 
            enable_months: this.e_enable_months == "" ? 0 : this.e_enable_months , 
            memo:  this.e_memo,
          }, sub : 
          this.contact_datas
        }
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; } 
        this.showMsg('新增成功!');     
        this.$refs.modalDialog.hide();    
        this.hideLoading();
        this.getLBDeliverMain();       
      })
      .catch((error) => { this.showError(error, true) }
      )      
    },  
    recordDoubleClick: function () {         
      this.e_isAdd = false;
      this.e_bill_id = this.e_selectData.bill_id;     
      this.e_bill_date = new Date(this.e_selectData.bill_date);
      this.e_enterprise_id = this.e_selectData.enterprise_id;
      this.e_contact = this.e_selectData.contact;
      this.e_contact_phone = this.e_selectData.contact_phone;
      this.e_warehouse_id = this.e_selectData.warehouse_id;
      this.e_fax = this.e_selectData.fax;
      this.e_deliver_mehtod = this.e_selectData.deliver_mehtod;
      this.e_deliver_country = this.e_selectData.deliver_country;
      this.e_deliver_address = this.e_selectData.deliver_address;
      this.e_memo = this.e_selectData.memo;
      this.e_check_id = this.e_selectData.check_id;
      this.e_enable_months = this.e_selectData.enable_months;
      this.e_service_years = this.e_selectData.service_years;
      this.e_source_bill_id = this.e_selectData.source_bill_id;
      this.e_bus_person_id = this.e_selectData.bus_person_id;
      this.e_total_pages = this.e_selectData.total_pages;
      this.editContactSettings = { allowEditing: this.e_isAdd || this.e_check_id == null, allowAdding: false, allowDeleting: false, showAddNewRow: false };
      this.$refs.modalDialog.show();  
    },
    beforeRender: function (args) {
      if (args.target.closest("td")) {
        this.$refs.tooltip.content = args.target.innerText;
      }
    },

    getLBDeliverMain: function () {           
      this.showLoading();
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: 'LBDeliver/Main',
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }              
          this.hideLoading();         
          this.datas = response.data.datas      
          this.e_selectRow = null;
          this.e_selectData = null;
          this.checkHeader();
      })
      .catch((error) => { this.showError(error, true) }
      )               
    },
    getStockSub: function (bill_id) {           
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `LBDeliver/Sub?bill_id=${bill_id}`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }              
          this.contact_datas = response.data.datas      
      })
      .catch((error) => { this.showError(error, true) }
      )               
    },
    getOrderToShipUse: function () {           
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `/LBOrder/Main/Use?enterprise_id=${this.e_enterprise_id}`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }              
        this.order_to_ship_datas = response.data.datas      
      })
      .catch((error) => { this.showError(error, true) }
      )               
    },
    getWarehouse: function () {           
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `/LBWarehouse/Dropdown`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }              
       
          this.warehouse_datas = response.data.datas      
      })
      .catch((error) => { this.showError(error, true) }
      )               
    },
    getNumber: function () {           
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `/General/Number?type=deliver`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }              
          this.e_bill_id = response.data.datas  
      })
      .catch((error) => { this.showError(error, true) }
      )               
    },
    getSales: function () {           
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `/Account/User/Dropdown`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }              
       
          this.sales_datas = response.data.datas      
      })
      .catch((error) => { this.showError(error, true) }
      )               
    },  
    getStockState: function () {           
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `/LBStock/State`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }              
          this.stock_datas = response.data.datas      
      })
      .catch((error) => { this.showError(error, true) }
      )               
    },

    getEnterprise: function () {           
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `/Enterprise/Dropdown`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }              
          this.enterprise_datas = response.data.datas      
      })
      .catch((error) => { this.showError(error, true) }
      )               
    },
    putReSend: function () {      
      this.axios({
          method: 'post',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `/LBDeliver/ReSend`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          data : {        
            bill_id: this.e_selectData.bill_id
          }
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }         
        this.showMsg('重新送至全鏈路完成!');       
        this.getLBDeliverMain();
      })
      .catch((error) => { this.showError(error, true) }
      )               
    },
    onOrderToShipSelect: function(e) {
      var v = this.order_to_ship_datas.filter(data => data.bill_id == e.item.dataset.value);
      this.e_o_bill_date = v[0].bill_date;
      this.e_o_no = v[0].row_id;
      this.e_o_volumes = v[0].volumes;
      this.e_o_style_id = v[0].style_id;
      this.e_o_style_name = v[0].style_name;
      this.e_o_start_label = "";
      this.e_o_end_label = "";
    },
    onEnterpriseSelect: function(e) {
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `Enterprise/ID?id=${e.item.dataset.value}`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }               
          this.e_enable_months = response.data.datas.enable_months;
          this.e_service_years = response.data.datas.service_years;
          this.e_deliver_address = response.data.datas.address;
          this.e_contact = response.data.datas.contact;
          this.e_contact_phone = response.data.datas.contact_phone;
          this.e_fax = response.data.datas.fax;
      })
      .catch((error) => { this.showError(error, true) }
      )      
    },

    showError: function (error) {     
      this.hideLoading();
      if (error.response.status == 400) {
        for(var key in error.response.data.errors){      
          this.$refs.toastRef.show( { title: '警告!', content: error.response.data.errors[key][0] , cssClass: 'e-toast-warning', icon: 'e-warning toast-icons' });           
        }
        return;
      }   
      if (error.response.status == 401) {
        localStorage.removeItem('token'); this.$router.push('/login');
        return;
      }
      this.$refs.toastRef.show( { title: '錯誤!', content: error.response.status, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' });
    },
    showMsg: function (msg) {
      this.$refs.toastRef.show( { title: '訊息!', content: msg, cssClass: 'e-toast-info', icon: 'e-info toast-icons' });
    },
    showLoading() {
      Loader = this.$loading.show({
        container: this.$refs.loadingContainer,
        canCancel: true, // default false
        onCancel: this.yourCallbackMethod,
        color: 'blue',
        loader: 'bars',  // spinner, dots, bars
        width: 164,
        height: 164,
        backgroundColor: 'black',
        opacity: 0.5,
        zIndex: 999,
      });
    },
    hideLoading() {
        Loader.hide();
    }
  },
  provide: {
    grid: [PdfExport, ExcelExport, Sort, DetailRow, Edit, Page, Toolbar, Filter, Reorder, Search]
  },
  created() {
    this.checkHeader();
    this.getLBDeliverMain();
    this.getEnterprise();
    this.getWarehouse();
    this.getSales();
    this.getLBStyle();
    this.getStockState();
  },
  mounted() {
  },
  beforeUpdate() {
  },
  beforeDestroy() {
  }
}
</script>
<style>
/* 設定 CustomerName 欄位的字體顏色 */
.blue-text {
  color: blue !important;
}

</style>
<style lang="scss" src="../../scss/base.scss"></style>
